<template>
  <div v-if="idProject === 'P3rw1Un80Yz3'">
    <nav-bar></nav-bar>
    <div class="container restaurant">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/restaurants')">{{ CONSTANTS.getCopy('STORERESTAURANT_BREADCRUMB_RESTAURANTS') }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('STORERESTAURANT_BREADCRUMB_NEW_RESTAURANT') }}</a></li>
          </ul>
        </nav>
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_NAME_LABEL') }}</label>
          <div class="control">
            <input :class="{'input-error': showErrors && !restaurant.name}"
                   type="text" v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_NAME_PLACEHOLDER')" v-model="restaurant.name">
          </div>
        </div>
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_CLIENT_ID_LABEL') }}</label>
          <div class="control">
            <input :class="{'input-error': showErrors && !restaurant.idClient}" type="text"
                   v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_CLIENT_ID_PLACEHOLDER')" v-model="restaurant.idClient">
          </div>
        </div>
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_LABEL') }}</label>
          <label v-if="showErrors && !checkSmsSelected" class="text-error">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_RADIO_LABEL') }}</label>
          <div class="control">
            <input type="radio" id="sms-yes" @change="toggleSmsSection(true)" name="sms">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_YES') }}
            <input type="radio" id="sms-no" @change="toggleSmsSection(false)" name="sms">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_NO') }}
          </div>
        </div>
        <div class="pbottom-1 pleft-1" v-if="showSmsSection">
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_CLIENT_SMS_ID_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.sms.idClientSms}"
                     type="text" v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_CLIENT_SMS_ID_PLACEHOLDER')" v-model="restaurant.sms.idClientSms">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_KEY_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.sms.keySms}" type="text"
                     v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_KEY_PLACEHOLDER')" v-model="restaurant.sms.keySms">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_SENDER_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.sms.senderSms}"
                     type="text" v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_SENDER_PLACEHOLDER')" v-model="restaurant.sms.senderSms">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_TEXT_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.sms.textSms}" type="text"
                     v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_TEXT_PLACEHOLDER')" v-model="restaurant.sms.textSms">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_ROUTE_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.sms.routeSms}"
                     type="text" v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_ROUTE_PLACEHOLDER')" v-model="restaurant.sms.routeSms">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_ALPHABET_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.sms.alfhabetSms}"
                     type="text" v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_SMS_ALPHABET_PLACEHOLDER')" v-model="restaurant.sms.alfhabetSms">
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_PLATFORM_LABEL') }}</label>
          <div class="control">
            <select :class="{'input-error': showErrors && !restaurant.platformType || restaurant.platformType == 0}" v-model="restaurant.platformType"  @change="togglePlatformSection">
              <option v-for="platform in platforms" :key="platform.id" :value="platform.id">{{ platform.name }}</option>
            </select>
          </div>
        </div>
        <div class="pbottom-1 pleft-1" v-if="showPlatformSection">
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_ID_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.platform.id}"  type="text"
                     v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_ID_PLACEHOLDER')" v-model="restaurant.platform.id">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_API_KEY_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.platform.apikey}"  type="text"
                     v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_API_KEY_PLACEHOLDER')" v-model="restaurant.platform.apikey">
            </div>
          </div>
          <div v-if="restaurant.platformType === 'COVERMANAGER'" class="field">
            <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_HOST_LABEL') }}</label>
            <div class="control">
              <input :class="{'input-error': showErrors && !restaurant.platform.host}" type="text"
                     v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_HOST_PLACEHOLDER')" v-model="restaurant.platform.host">
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_DINERS_LABEL') }}</label>
          <div class="control">
            <input :class="{'input-error': showErrors && !restaurant.diners}" type="text"
                   v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_DINERS_PLACEHOLDER')" v-model="restaurant.diners">
          </div>
        </div>
        <div class="field">
          <label class="label">{{ CONSTANTS.getCopy('STORERESTAURANT_FIELD_AGENT_LABEL') }}</label>
          <div class="control">
            <input :class="{'input-error': showErrors && !restaurant.agent}"
                   type="text" v-bind:placeholder="CONSTANTS.getCopy('STORERESTAURANT_FIELD_AGENT_PLACEHOLDER')" v-model="restaurant.agent">
          </div>
        </div>
        <div class="button is-primary is-right-bottom" @click="storeRestaurant">
          <span class="icon"><i class="fas fa-save fa-lg"></i></span>
          <span class="is-capitalized">{{ CONSTANTS.getCopy('STORERESTAURANT_SAVE_BUTTON') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      restaurant: {
        name: null,
        idClient: null,
        isSms: false,
        platformType: null,
        diners: null,
        agent: null,
        sms: {
          idClientSms: null,
          keySms: null,
          senderSms: null,
          textSms: null,
          routeSms: null,
          alfhabetSms: null
        },
        platform: {
          id: null,
          apikey: null,
          host: null
        }
      },
      showSmsSection: false,
      showPlatformSection: false,
      showErrors: false,
      idProject: localStorage.getObject('user.idProject'),
      platforms: []
    }
  },
  beforeMount () {
    this.getPlatforms()
  },
  methods: {
    toggleSmsSection (value) {
      this.restaurant.isSms = value
      this.showSmsSection = value
    },
    togglePlatformSection () {
      if (parseInt(this.restaurant.platformType) !== 0) {
        this.showPlatformSection = true
        return
      }
      this.showPlatformSection = false
    },
    checkSmsSelected () {
      return (document.querySelector('#sms-yes').checked || document.querySelector('#sms-no').checked)
    },
    storeRestaurant () {
      this.showErrors = false
      if (!this.restaurant.name || !this.restaurant.idClient || !this.restaurant.diners || !this.restaurant.agent ||
        !this.checkSmsSelected() || (this.restaurant.isSms && (!this.restaurant.sms.alfhabetSms || !this.restaurant.sms.routeSms ||
          !this.restaurant.sms.textSms || !this.restaurant.sms.senderSms ||
          !this.restaurant.sms.keySms || !this.restaurant.sms.idClientSms)) ||
        !this.restaurant.platformType || parseInt(this.restaurant.platformType) === 0 || ((!this.restaurant.platform.apikey || !this.restaurant.platform.id)) ||
        (this.restaurant.platformType === 'COVERMANAGER' && !this.restaurant.platform.host)
      ) {
        this.showErrors = true
        return
      }
      this.api.post('/RestaurantRegister', this.restaurant).then((response) => {
        this.$router.push('/restaurants')
        location.reload()
      })
    },
    getPlatforms () {
      this.api.post('/DataTypePlatformRestaurantList').then((response) => {
        this.platforms = response.typesPlatforms
      })
    }
  }
}
</script>

<style>
.restaurant .field .control input[type="text"] {
  width: 80%;
}
.restaurant .field .control input[type="radio"] {
  width: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/Restaurants/StoreRestaurant.vue